export default __webpack_public_path__ + "static/media/iqi_logo_only.1173dffb.png";